export const TEAM_PROFILE_URL_PATTERNS = {
    discord: "https://discord.com/users/{id}",
    linkedin: "https://www.linkedin.com/in/{handle}/",
    github: "https://github.com/{handle}/",
    npm: "https://www.npmjs.com/~{handle}",
};
export const TEAM_MEMBERS = [
    {
        id: "iwilldiehere",
        name: "iwilldiehere",
        copy: {
            "fr-FR": {
                role: "Fondateur et développeur de LogsCord",
                status: "Fondateur",
                location: "Suisse / Europe",
                description: "Fondateur et développeur de LogsCord, {name} conçoit l’ensemble de la plateforme : collecte temps réel, recherche, infrastructure, sécurité, expérience produit et protection des données.",
                message: "Je développe LogsCord avec une conviction simple : une plateforme d’observabilité peut être extrêmement puissante sans oublier les personnes, les communautés et les données qu’elle protège.",
                motto: "La puissance n’a de valeur que lorsqu’elle reste responsable.",
            },
            "en-US": {
                role: "Founder and developer of LogsCord",
                status: "Founder",
                location: "Switzerland / Europe",
                description: "Founder and developer of LogsCord, {name} designs the entire platform: real-time collection, search, infrastructure, security, product experience and data protection.",
                message: "I build LogsCord around one simple belief: an observability platform can be extremely powerful without forgetting the people, communities and data it protects.",
                motto: "Power only has value when it remains responsible.",
            },
        },
        discord: {
            userId: "1464758198291529953",
            usernameFallback: null,
            displayNameFallback: "iwilldiehere",
            tagFallback: null,
        },
        socials: {
            linkedin: {
                handle: "realalphabet",
            },
            github: {
                handle: "RealAlphabet",
            },
            npm: null,
            portfolio: null,
        },
    },
];
function fillTeamProfileUrl(pattern, placeholder, value) {
    return pattern.replace(`{${placeholder}}`, encodeURIComponent(value.replace(/^@/, "")));
}
export function buildTeamDiscordProfileUrl(userId) {
    return fillTeamProfileUrl(TEAM_PROFILE_URL_PATTERNS.discord, "id", userId);
}
export function buildTeamSocialProfileUrl(platform, handle) {
    return fillTeamProfileUrl(TEAM_PROFILE_URL_PATTERNS[platform], "handle", handle);
}
export function formatTeamMemberTemplate(template, displayName) {
    return template.replaceAll("{name}", displayName);
}
export function createFallbackPublicTeamView() {
    return {
        members: TEAM_MEMBERS.map((member) => ({
            id: member.id,
            name: member.name,
            copy: member.copy,
            discord: {
                userId: member.discord.userId,
                username: member.discord.usernameFallback,
                displayName: member.discord.displayNameFallback,
                handle: member.discord.tagFallback,
                avatarUrl: null,
            },
            socials: {
                linkedin: member.socials.linkedin,
                github: member.socials.github,
                npm: member.socials.npm,
                portfolio: member.socials.portfolio,
            },
        })),
    };
}
export function isPublicTeamView(value) {
    return typeof value === "object"
        && value !== null
        && "members" in value
        && Array.isArray(value.members);
}
//# sourceMappingURL=team.js.map